import {
  MAX_UPLOAD_SIZE_MB as ENV_MAX_UPLOAD_SIZE_MB,
  MAX_MEDIA_DURATION_MINUTES as ENV_MAX_MEDIA_DURATION_MINUTES,
} from '../../../constants/main';

const FALLBACK_MAX_UPLOAD_SIZE_MB = 1000;
const FALLBACK_MAX_MEDIA_DURATION_MINUTES = 20;

export const MAX_UPLOAD_SIZE_MB = Number.isFinite(ENV_MAX_UPLOAD_SIZE_MB)
  ? ENV_MAX_UPLOAD_SIZE_MB
  : FALLBACK_MAX_UPLOAD_SIZE_MB;
export const MAX_UPLOAD_SIZE_BYTES = MAX_UPLOAD_SIZE_MB * 1024 * 1024;
export const MAX_MEDIA_DURATION_MINUTES = Number.isFinite(ENV_MAX_MEDIA_DURATION_MINUTES)
  ? ENV_MAX_MEDIA_DURATION_MINUTES
  : FALLBACK_MAX_MEDIA_DURATION_MINUTES;
export const MAX_MEDIA_DURATION_SECONDS = MAX_MEDIA_DURATION_MINUTES * 60;

// eslint-disable-next-line no-console
console.log('[uploadLimits] resolved limits', {
  MAX_UPLOAD_SIZE_MB,
  MAX_MEDIA_DURATION_MINUTES,
});

const formatBytes = (bytes) => {
  if (!Number.isFinite(bytes)) return null;
  const mb = bytes / (1024 * 1024);
  if (mb >= 1024) {
    const gb = mb / 1024;
    return { value: gb >= 100 ? gb.toFixed(0) : gb.toFixed(1), unit: 'GB' };
  }
  return { value: mb >= 100 ? mb.toFixed(0) : mb.toFixed(1), unit: 'MB' };
};

const formatDuration = (seconds) => {
  if (!Number.isFinite(seconds)) return null;
  const totalSeconds = Math.max(0, Math.round(seconds));
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const secs = totalSeconds % 60;
  if (hours > 0) {
    return `${hours}h ${minutes}m ${secs}s`;
  }
  return `${minutes}m ${secs}s`;
};

export const getFileSizeErrorMessage = (fileName, fileSizeBytes) => {
  const maxSizeLabel = formatBytes(MAX_UPLOAD_SIZE_BYTES);
  const maxSizeDisplay = maxSizeLabel
    ? `${maxSizeLabel.value} ${maxSizeLabel.unit}`
    : `${MAX_UPLOAD_SIZE_MB} MB`;
  const sizeLabel = formatBytes(fileSizeBytes);
  const sizeSuffix = sizeLabel ? ` (Size: ${sizeLabel.value} ${sizeLabel.unit})` : '';
  if (fileName) {
    return `"${fileName}" exceeds maximum allowed size of ${maxSizeDisplay}.${sizeSuffix}`;
  }
  return `File exceeds maximum allowed size of ${maxSizeDisplay}.${sizeSuffix}`;
};

export const getDurationErrorMessage = (fileName, durationSeconds) => {
  const durationLabel = formatDuration(durationSeconds);
  const durationSuffix = durationLabel ? ` (Duration: ${durationLabel})` : '';
  if (fileName) {
    return `"${fileName}" exceeds maximum allowed duration of ${MAX_MEDIA_DURATION_MINUTES} minutes.${durationSuffix}`;
  }
  return `Media duration exceeds maximum allowed duration of ${MAX_MEDIA_DURATION_MINUTES} minutes.${durationSuffix}`;
};

export const isFileSizeExceeded = (fileSizeBytes) =>
  Number.isFinite(fileSizeBytes) && fileSizeBytes > MAX_UPLOAD_SIZE_BYTES;

export const isDurationExceeded = (durationSeconds) =>
  Number.isFinite(durationSeconds) && durationSeconds > MAX_MEDIA_DURATION_SECONDS;
